import React, {useEffect, useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {useHistory, useParams} from "react-router-dom";
import {Actions} from "../../../client/Actions";
import {Alert, Badge, Col, Row} from "react-bootstrap";
import CustomAccordion from "../../components/accordion/CustomAccordion";
import renderUtils from "../../helpers/renderUtils";
import PartInstallation from "./PartInstallation";
import CardForm from "../../components/form/CardForm";
import {fields as ProductionFillAllFormConfig} from "./ProductionFillAllFormConfig";
import {fields as ProductionDetailsFormConfig} from "./ProductionDetailsFormConfig";
import lineUtils from "../../helpers/lineUtils";
import {toast} from "react-toastify";
import MachineFormatParts from "../format/MachineFormatParts";
import {InstallationBar} from "./InstallationBar";
import {Summary} from "../../components/summary/Summary";
import {NewTabBadge} from "../../components/badge/NewTabBadge";
import CustomCard from "../../components/CustomCard";
import utils from "../../helpers/utils";
import MachineParameterTypes from "./MachineParameterTypes";
import Tooltip from "../../components/tooltip/Tooltip";
import {getUser, hasProductionFullAccess} from "../../helpers/jwt";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import dateUtils from "../../helpers/dateUtils";
import { useTranslation } from 'react-i18next';
import { useModels } from "../../helpers/models";


const PartInstallationComponentPage = ({}) => {
    let {lineId} = useParams();
    let {simulationId} = useParams();
    let {productionId} = useParams();

    const models = useModels();

    const [loader, setLoader] = useState(false);
    const [activeKey, setActiveKey] = useState();
    const [formats, setFormats] = useState();
    const [partsByFormatPart, setPartsByFormatPArt] = useState();
    const [line, setLine] = useState();
    const [reload, setReload] = useState();
    const [installations, setInstallations] = useState()
    const [activeProduction, setActiveProduction] = useState()
    const [activeProductionLoaded, setActiveProductionLoaded] = useState(false)
    const [dictionaries, setDictionaries] = useState()
    const [partsCount, setPartsCount] = useState();
    const [totalPartsCount, setTotalPartsCount] = useState();
    const [currentTotalPartsCount, setCurrentTotalPartsCount] = useState();
    const [notSavedInstallsCount, setNotSavedInstallsCount] = useState(0);
    const [readOnly, setReadOnly] = useState(false);
    const [productionHistory, setProductionHistory] = useState();
    const [allInstalled, setAllInstalled] = useState(false);
    const [installedFormats, setInstalledFormats] = useState([]);
    const [simulation, setSimulation] = useState([]);
    const [historicalProduction, setHistoricalProduction] = useState();


    const [scrollTarget, setScrollTarget] = useState(null);
    const [machinesRefs, setMachinesRefs] = useState({});
    const [cleaningValidDuration, setCleaningValidDuration] = useState();

    const { t } = useTranslation();

    function loadIsAllInstalled() {
        if (!simulationId) {
            Actions.get("line/" + lineId + "/isFullInstalled", setAllInstalled)
        }
    }

    const loadSimulation = () => {
        if (simulationId) {
            Actions.get("lineInstallationSimulation/" + simulationId, simulationLoaded)
        }
    };

    const loadHistoricalProduction = () => {
        if (productionId) {
            Actions.get("production/" + productionId, historicalProductionLoaded)
        }
    };


    const loadData = () => {
        setLoader(true)

        utils.loadCleaningValidDuration(setCleaningValidDuration)
        loadIsAllInstalled();
        loadFormats()
        loadLine();
        loadSimulation();
        loadHistoricalProduction();
        loadActiveProduction()
        loadProductionHistory()
    };


    function loadLine() {
        Actions.get("line/" + lineId, setLine)
    }

    const loadActiveProduction = () => {
        if (!simulationId && !productionId) {
            Actions.get("production/active/" + lineId, productionLoaded)
        }
    };


    const simulationLoaded = (data) => {
        setSimulation(data)
        installsLoaded(data.partInstallationSimulations)
        setActiveProductionLoaded(true)
        setLoader(false)

    };

    const historicalProductionLoaded = (data) => {
        setHistoricalProduction(data)
        installsLoaded(data.partInstallations)
        setActiveProductionLoaded(true)
        setLoader(false)
    };


    const loadInstalls = () => {
        Actions.get("line/" + lineId + "/installation", installsLoaded)
    };

    const loadFormats = () => {
        Actions.get("format/forPackingLine?packingLineId=" + lineId, formatsLoaded)
    };

    const loadProductionHistory = () => {
        if (!simulationId && !productionId) {
            Actions.get("production/history/" + lineId, setProductionHistory)
        }
    };

    const productionLoaded = (loadedActiveProduction) => {
        setActiveProduction(loadedActiveProduction)
        setActiveProductionLoaded(true)

        if (!loadedActiveProduction) {
            loadInstalls()
        } else {
            installsLoaded(loadedActiveProduction.partInstallations)
        }
    };

    const installsLoaded = (loaded) => {
        loaded.forEach(install => {
            install.originalPart = install.part
            install.status = "INSTALLED"
        })
        setInstallations(loaded)
    };
    const formatsLoaded = (loaded) => {
        const tmp = loaded.filter(f => f.formatStatus === "STORAGE")

        tmp["format"] = tmp;
        setDictionaries(tmp);


        setFormats(tmp)
    };


    const saveInstalls = () => {
        const toSave = installations
            .filter(install => install.status === "NOT_SAVED")
            .map(install => {
                return {
                    formatPartId: install.formatPartId,
                    partId: install?.part?.id
                }
            })
        setLoader(true)
        if (simulationId) {
            Actions.post("lineInstallationSimulation/" + simulationId + "/install", toSave, onSavedInstalls)
        } else {
            Actions.post("line/" + lineId + "/installation", {partInstallations: toSave}, onSavedInstalls)
        }
    };

    const onSavedInstalls = () => {
        if (simulationId) {
            loadSimulation()
        } else {
            loadIsAllInstalled();
            loadInstalls()
            loadFormats()
        }
    };

    const prepareParts = () => {
        if (formats) {
            const result = {}

            formats.forEach(format => {
                    format.formatParts.filter(
                        part => productionId ? true : part.partStatus !== "WITHDRAWN"
                    ).forEach(part => {
                        const partsList = result[part.formatPart.id] || []
                        partsList.push(part)
                        part.formatId = format.id
                        part.formatName = format.nameAndDose
                        result[part.formatPart.id] = partsList
                    })
                }
            )

            setPartsByFormatPArt(result)
        }

    };

    useEffect(() => {
        if (scrollTarget && machinesRefs[scrollTarget]) {
            machinesRefs[scrollTarget].current.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
            setScrollTarget(null); // Clear after scrolling
        }
    }, [scrollTarget, machinesRefs]);


    function onSelectedAllFromFormat() {
        setLoader(false);
        toast.success(t("messages.success"));
    }

    const clearAllInstalls = () => {
        setLoader(true)

        const toInstall = [];
        installations.forEach(install => {
            if (install.part) {
                toInstall.push({
                    formatPartId: install.formatPartId,
                    selectedPart: null
                })
            }
        });

        installParts(toInstall, onSelectedAllFromFormat)
    };

    const selectAllFromFormat = (format) => {
        setLoader(true)
        const partsByFormatPartId = {};

        format.formatParts.forEach(p => {
            partsByFormatPartId[p.formatPart.id] = p;
        });

        const allFormatParts = lineUtils.collectAllFormatParts(line);

        const toInstall = [];
        allFormatParts.forEach(formatPart => {
            const part = partsByFormatPartId[formatPart.id];
            if (part && (simulationId ? part.partStatus !== "WITHDRAWN" : part.partStatus === "STORAGE")) {
                toInstall.push({
                    formatPartId: formatPart.id,
                    selectedPart: part
                })
            }
        });
        if (toInstall.length === 0) {
            toast.warning(t("common.no_available_parts"));
            setLoader(false)
        } else {
            installParts(toInstall, onSelectedAllFromFormat)

        }

    };

    useEffect(() => {
        if (line) {
            const partsCounts = {};

            line.machines.forEach(m => {
                partsCounts[m.id] = lineUtils.partsCount(m);
            });

            const totalParts = Object.values(partsCounts).reduce((sum, count) => sum + count, 0);

            setTotalPartsCount(totalParts);
            setPartsCount(partsCounts);


            const refs = {};
            line.machines.forEach(machine => {
                refs[machine.id] = refs[machine.id];
            });
            setMachinesRefs(refs);
        }
    }, [line]);


    const scrollToMachine = (machineId) => {
        setScrollTarget(machineId);
    };

    useEffect(loadData, [reload]);
    useEffect(prepareParts, [formats]);
    useEffect(() => setReadOnly(!!activeProduction), [activeProduction]);
    // useEffect(determineCurrentActiveKey, [completedProcesses]);
    useEffect(() => {
        scrollToMachine(activeKey);
    }, [activeKey]);

    useEffect(() => {
        if (installations) {
            const current = installations.filter(install => install.part).length
            const ignoreCount = installations.filter(install => !install.part && install.ignore).length
            setNotSavedInstallsCount(installations.filter(install => install.status === "NOT_SAVED").length)
            setCurrentTotalPartsCount(current)

            setInstalledFormats(utils.unique(installations.filter(install => install.part).map(install => install.part.formatId)))
        }


    }, [installations]);


    function title() {
        return <>
            {t("menu.production")}
            {" "}
            {
                <NewTabBadge
                    tooltip={t("production.more_about_line")}
                    newTabUrl={"#/line/" + line?.id}
                    className={"ml-2"}>
                    {line?.name}
                </NewTabBadge>
            }
        </>
    }

    function simulationTitle() {
        return <>
            {
                <NewTabBadge
                    tooltip={t("production.more_about_line")}
                    newTabUrl={"#/line/" + line?.id}
                    className={"mr-1"}>
                    {line?.name}
                </NewTabBadge>
            }

            <Badge className={"outline-secondary font-max mr-1"}>{t("menu.simulation")}</Badge>
            {
                <Badge variant={"primary"}
                       className={"mr-1"}>
                    {simulation?.name}
                </Badge>
            }
        </>
    }

    function historicalProductionTitle() {
        return <>
            {
                <NewTabBadge
                    tooltip={t("production.more_about_line")}
                    newTabUrl={"#/line/" + line?.id}
                    className={"mr-2"}>
                    {line?.name}
                </NewTabBadge>
            }

            <Badge className={"outline-secondary font-max mr-1"}>{t("production.historical_production")}</Badge>
        </>
    }


    const partInstallation = {
        field: "part",
        label: t("production.part_from_format"),
        sort: "desc",
        width: 200,
        type: "custom",
        custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState, externalState2) {
            return (
                <PartInstallation
                    simulation={simulationId}
                    formatPart={row}
                    readOnly={!!activeProduction || !!productionId || !hasProductionFullAccess()}
                    installations={externalState}
                    cleaningValidDuration={cleaningValidDuration}
                    installPart={(selectedPart, formatPartId) => installParts([{
                        selectedPart: selectedPart,
                        formatPartId: formatPartId
                    }])}
                    parts={externalState2 ? (externalState2[row.id] || []) : []}
                />
            );
        }
    };


    const partInstallationStatus = {
        field: "status",
        label: t("production.installation_status"),
        sort: "desc",
        width: 200,
        type: "custom",
        custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
            const currentInstallation = externalState.find(install => install.formatPartId === row.id)

            console.log("currentInstallation: ", currentInstallation)

            if (currentInstallation?.status === "INSTALLED") {
                return <Alert variant={"primary"} className={"font-max mb-0"}>{t("production.installed")}</Alert>
            } else if (currentInstallation?.status === "NOT_SAVED") {
                return <Alert variant={"warning"} className={"font-max mb-0"}>{t("production.not_saved")}</Alert>
            } else if (row.ignore) {
                return <Tooltip tooltip={t("production.ignored")}>
                    <Alert variant={"success"} className={"font-max mb-0"}>{t("production.not_installed")}</Alert>
                </Tooltip>

            } else {
                return <Alert variant={"secondary"} className={"font-max mb-0"}>{t("production.not_installed")}</Alert>

            }
        }
    };

    const installParts = (toInstalls, onFinish) => {
        let updatedInstalls = [...installations]; // Create a copy of the installations list

        toInstalls.forEach(toInstall => {
            updatedInstalls = installPart(updatedInstalls, toInstall.selectedPart, toInstall.formatPartId); // Update with each call
        });

        setInstallations(updatedInstalls); // Set the final updated state
        if (onFinish) {
            onFinish();
        }
    };

    function calculateStatus(part, originalPart) {
        if (!originalPart && !part) {
            return "NOT_INSTALLED"
        } else if (originalPart?.id !== part?.id) {
            return "NOT_SAVED"
        } else {
            return "INSTALLED"
        }
    }

    const installPart = (currentInstalls, selectedPart, formatPartId) => {
        const installationExists = currentInstalls.some(installation => installation.formatPartId === formatPartId);

        if (installationExists) {
            // Update the installation if it exists
            console.log("update installation for formatPart: ", formatPartId)

            return currentInstalls.map(installation => {
                if (installation.formatPartId === formatPartId) {
                    return {
                        ...installation,
                        status: calculateStatus(selectedPart, installation.originalPart),
                        part: selectedPart
                    };
                }
                return installation;
            });
        } else {
            console.log("add new installation for formatPart: ", formatPartId)
            return [
                ...currentInstalls,
                {
                    formatPartId: formatPartId,
                    status: "NOT_SAVED",
                    part: selectedPart
                }
            ];
        }
    };


    function createNote(note, onSaved) {
        const noteWithUser = `(${getUser()}): ${note}`;
        const noteWithDate = `${dateUtils.now()} - ${noteWithUser}`;

        setLoader(true);
        const toSave = activeProduction.notes
            ? activeProduction.notes + "noteSeparator" + noteWithDate
            : noteWithDate;

        Actions.put("production/" + activeProduction.id, {notes: toSave.trim()}, () => {
            if (onSaved) {
                onSaved();
            }
            loadActiveProduction();
        });
        setLoader(false);
    }


    return (
        <>
            <Loader loader={loader}/>
            {


                <CustomContainer
                    title={<>
                        {simulationId && simulationTitle()}
                        {productionId && historicalProductionTitle()}
                        {!productionId && !simulationId && title()}
                    </>}
                    miniNavClassName={simulationId ? "alert-primary" : ""}
                    parent={<>
                        {simulationId &&
                            <LinkIconButton
                                model={models.production}
                                link={models.production.url + "/" + lineId}
                            />
                        }
                        {!simulationId &&
                            <LinkIconButton
                                model={models.production}
                            />
                        }


                    </>
                    }
                    subtitle={activeProductionLoaded &&

                        <InstallationBar
                            simulation={!!simulationId}
                            historicalProduction={historicalProduction}
                            activeProduction={activeProduction}
                            line={line}
                            installations={installations}
                            loadData={loadData}
                            allInstalled={allInstalled}
                            setLoader={setLoader}
                            onClearInstalls={() => {
                                clearAllInstalls()
                            }}
                            productionHistory={productionHistory}
                            currentTotalPartsCount={currentTotalPartsCount}
                            totalPartsCount={totalPartsCount}
                            notSavedInstallsCount={notSavedInstallsCount}
                            onCancel={() => {
                                setLoader(true)
                                loadInstalls()
                            }}
                            onSave={saveInstalls}

                        />
                    }>

                    <Col md={12}>
                        <>
                            {dictionaries && !activeProduction && !historicalProduction && line &&
                                <Row>
                                    {hasProductionFullAccess() &&
                                        <CardForm
                                            withoutHeader={true}
                                            setLoader={setLoader}
                                            className={"print-hide"}
                                            fields={ProductionFillAllFormConfig(simulationId, line.machines.map(m => m.id), t)}
                                            width={5}
                                            dictionaries={dictionaries}
                                            withoutCancel={true}
                                            saveButton={t("production.install")}
                                            disableLoader={true}
                                            customSave={(data, onSaved) => {
                                                if (data.format) {
                                                    selectAllFromFormat(data.format)
                                                    onSaved()
                                                }
                                            }}
                                        />
                                    }
                                    {productionHistory && productionHistory[0] &&
                                        <Col md={7}>
                                            <Alert variant={"primary"}>

                                                {t("production.last_production_ended")}
                                                {" "}{t("production.on_date")} <strong>{productionHistory[0].productionEndDate}</strong> {t("production.by_user")}
                                                {" "}<strong>{productionHistory[0].productionEndUsername}</strong> {t("production.with_result")}
                                                {" "}<strong>{productionHistory[0].quantity} </strong> {t("production.produced_packages")}
                                            </Alert>
                                        </Col>

                                    }
                                </Row>
                            }
                            {(activeProduction || historicalProduction) &&
                                <Row>
                                    <CardForm
                                        title={t("forms.production_details")}
                                        setLoader={setLoader}
                                        fields={ProductionDetailsFormConfig}
                                        width={7}
                                        initialData={activeProduction || historicalProduction}
                                        readOnly={true}
                                    />
                                    <Col md={5}>
                                        <Row>
                                            <Summary
                                                width={12}
                                                tab={false}
                                                height={"328px"}
                                                title={t("common.notes")}
                                                emptyLabel={t("common.no_notes")}
                                                summary={activeProduction?.notes || historicalProduction?.notes}
                                                creation={!productionId}
                                                setLoader={setLoader}
                                                separator={"noteSeparator"}
                                                create={createNote}
                                            />
                                        </Row>
                                    </Col>
                                </Row>
                            }
                        </>
                        {installedFormats.length > 0 &&

                            <Row>
                                <CustomCard withoutHeader={true}>

                                    <div className={"d-flex"}>
                                        <Badge
                                            className={"outline-secondary mr-2 font-max"}
                                        >
                                            {t("production.installed_formats")}
                                        </Badge>
                                        {
                                            installedFormats.map(formatId => {
                                                return <NewTabBadge
                                                    tooltip={t("production.more_about_format")}
                                                    className={"mr-2"}
                                                    newTabUrl={"#/management/" + formatId}
                                                >
                                                    {formatId}
                                                </NewTabBadge>
                                            })
                                        }
                                    </div>

                                </CustomCard>
                            </Row>
                        }
                        {line && installations && partsByFormatPart &&

                            <Row>
                                <Col>
                                    <CustomAccordion
                                        defaultActiveKey={undefined}
                                        items={line.machines
                                            .filter(m => m.formatPartsCategories?.length > 0)
                                            .map(machine => {
                                                return {
                                                    title: <>
                                                        {!simulationId && !productionId &&
                                                            <MachineParameterTypes
                                                                machine={machine}
                                                                setLoader={setLoader}
                                                                readOnly={!!activeProduction || !hasProductionFullAccess()}
                                                            />
                                                        }
                                                        <Badge variant={"primary"} className={"mr-2"}>
                                                            {renderUtils.renderMachineType(machine, t)}
                                                        </Badge>
                                                        <Badge variant={"secondary"} className={"mr-2 font-max"}>
                                                            {renderUtils.renderMachine(machine)}
                                                        </Badge>

                                                    </>,
                                                    completable: false,
                                                    eventKey: machine.id + "",
                                                    content:
                                                        <Row>
                                                            <Col>
                                                                <MachineFormatParts
                                                                    machine={machine}
                                                                    setLoader={setLoader}
                                                                    reload={reload}
                                                                    readOnly={false}
                                                                    withHeader={false}
                                                                    checkAllByDefault={false}
                                                                    externalConfigs={installations}
                                                                    externalConfigs2={partsByFormatPart}
                                                                    additionalColumns={[partInstallation, partInstallationStatus]}
                                                                />
                                                            </Col>
                                                        </Row>
                                                }
                                            })}
                                    />
                                </Col>
                            </Row>
                        }
                    </Col>


                    <Col md={12}>
                        <div className={"footer"}></div>
                    </Col>
                </CustomContainer>
            }
        </>
    )
        ;
};

export default PartInstallationComponentPage;
